import { Plus } from 'lucide-react';

import { Sheet, SheetContent } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { MedicalRecordsRequestStatus } from './MedicalRecordsRequestStatus';

// Drawer for a referral's medical-records request lifecycle. Opened from the
// Medical Records column icon in OverviewTable. The request-status form fills
// the left column; the Comment column on the right is an intentional empty
// placeholder until the comment flow is scoped.
function MedicalRecordsDrawer({ open, onClose, referral, onSaved }) {
  return (
    <Sheet open={open} onOpenChange={() => onClose?.()}>
      <SheetContent onClose={onClose}>
        <div className="px-6 py-4 pr-12 border-b border-border">
          <h2 className="text-left text-lg font-semibold text-foreground">
            Medical Records{referral?.referral_id ? ` ${referral.referral_id}` : ''}
          </h2>
        </div>

        <div className="flex-1 min-h-0 grid grid-cols-[1fr_37.5vw] gap-6">
          {/* Left: request-status form. Only mounted while open so its
              load-on-open fetch and unsaved draft are scoped to an actual
              viewing — reopening starts fresh, and a closed drawer does no
              work. */}
          {open ? (
            <MedicalRecordsRequestStatus
              referral={referral}
              open={open}
              onCancel={onClose}
              onSaved={onSaved}
            />
          ) : (
            <div />
          )}

          {/* Right: comments — placeholder for now. */}
          <div className="flex flex-col min-h-0 pr-6 py-6 gap-2.5">
            <div className="flex items-center gap-2 min-h-[28px]">
              <Button variant="outline" size="sm" className="h-7 w-7 p-0" aria-label="Add comment" disabled>
                <Plus className="h-3.5 w-3.5" />
              </Button>
              <h3 className="text-sm font-semibold text-foreground">Comment</h3>
            </div>
            <div
              data-testid="medical-records-comment-placeholder"
              className="flex-1 min-h-0 bg-card rounded-lg border border-border"
            />
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}

export { MedicalRecordsDrawer };
